<div
  class="w-100"
  [ngClass]="{
    'wizard-small-input-wrapper': inputSettings.isSmall,
    'wizard-input-wrapper': !inputSettings.isSmall
  }"
  [@opacityAnimation]
>
  <label [for]="inputSettings.id">{{ inputSettings.label }}</label>
  <input
    *ngIf="inputSettings.type !== 'date'"
    [type]="inputSettings.type"
    [id]="inputSettings.id"
    [value]="inputSettings.value"
    (input)="inputSettings.inputFunction($event)" 
    class="w-100"
    autofocus
  />
</div>

